import http from '../../../plugins/axios';

export default {

    getUserInfo(data) {
        return http.get({
            url: '/admin/trade/user/info',
            data: data
        })
    },
    alterTradeUserPhone(data) {
        return http.post({
            url: '/admin/trade/user/alterPhone',
            data: data,
            dataType: 'form'
        });
    },
    alterTradeUserEmail(data) {
        return http.post({
            url: '/admin/trade/user/alterEmail',
            data: data,
            dataType: 'form'
        });
    }
}
